import { NgModule } from '@angular/core';

import { BgGradientPipe } from './bg-gradient.pipe';

@NgModule({
    declarations: [BgGradientPipe],
    exports: [BgGradientPipe],
})
export class CmpsBgGradientModule {}
